import React, { useMemo } from 'react';

import { setViolation, type MatchScoreDraft } from './scoring-match-draft';
import type { MatchItem } from './scoring-types';

interface Props {
  match: MatchItem;
  draft: MatchScoreDraft;
  cancelLabel: string;
  onCancel: () => void;
}

export const ScoringMatchForm: React.FC<Props> = ({ match, draft, cancelLabel, onCancel }) => {
  const scoreOptions = useMemo(
    () => Array.from({ length: match.setEntry.maxScore + 1 }, (_, score) => score),
    [match.setEntry.maxScore],
  );

  return (
    <form onSubmit={draft.submit} className="scoring-match-form">
      {draft.visibleSets.map((set, index) => (
        <div key={index} className="scoring-set-block">
          <div className="scoring-set-row">
            <span className="scoring-set-label">Set {index + 1}</span>
            <select
              value={set.p1}
              onChange={(event) => draft.updateSet(index, 'p1', event.target.value)}
              className="scoring-set-input"
              aria-label={`Set ${index + 1} — ${match.player1Name}`}
              data-testid={`set-${index}-p1`}
            >
              <option value="">—</option>
              {scoreOptions.map((score) => (
                <option key={score} value={score}>{score}</option>
              ))}
            </select>
            <span className="scoring-set-sep">:</span>
            <select
              value={set.p2}
              onChange={(event) => draft.updateSet(index, 'p2', event.target.value)}
              className="scoring-set-input"
              aria-label={`Set ${index + 1} — ${match.player2Name}`}
              data-testid={`set-${index}-p2`}
            >
              <option value="">—</option>
              {scoreOptions.map((score) => (
                <option key={score} value={score}>{score}</option>
              ))}
            </select>
          </div>
          {setViolation(match.setEntry, set) && (
            <p className="scoring-set-violation" data-testid={`set-${index}-violation`}>
              {setViolation(match.setEntry, set)}
            </p>
          )}
        </div>
      ))}

      {draft.error && (
        <p role="alert" data-testid="submit-error" className="scoring-submit-error">
          {draft.error}
        </p>
      )}

      <div className="scoring-form-actions">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={draft.submitting || draft.blocked}
          data-testid="submit-result"
        >
          {draft.submitting ? '…' : 'Zapisz wynik'}
        </button>
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          {cancelLabel}
        </button>
      </div>
    </form>
  );
};

export default ScoringMatchForm;
